module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"store":"Store","type_store":"Type store","no_result":"No result. Type to search for a store."}}')
  delete Component.options._Ctor
}
